type CategoryState = {
	selectedOptionsCategory: string[];
	count: number;
};

type CategoryItem = {
	id: string;
	value: number;
	checked: boolean;
};

type CategoryAction =
	| { type: "INITIALIZE_OPTIONS"; payload: { categories: CategoryItem[] } }
	| { type: "TOGGLE_OPTION"; payload: { id: string; value: number } }
	| { type: "RESET" };

export const categoryReducer = (state: CategoryState, action: CategoryAction): CategoryState => {
	switch (action.type) {
		case "INITIALIZE_OPTIONS": {
			const selected = action.payload.categories.filter((c) => c.checked);
			return {
				selectedOptionsCategory: selected.map((c) => c.id),
				count: selected.reduce((acc, c) => acc + c.value, 0),
			};
		}

		case "TOGGLE_OPTION": {
			const { id, value } = action.payload;
			const isSelected = state.selectedOptionsCategory.includes(id);

			return {
				selectedOptionsCategory: isSelected
					? state.selectedOptionsCategory.filter((sid) => sid !== id)
					: [...state.selectedOptionsCategory, id],
				count: isSelected ? state.count - value : state.count + value,
			};
		}

		case "RESET": {
			return { selectedOptionsCategory: [], count: 0 };
		}
		default:
			return state;
	}
};
